import { createSlice } from '@reduxjs/toolkit'

import * as types from 'constants/action_types'
import * as pages from 'constants/pages'
import { FETCH_CURRENT_USER_SUCCESS } from 'ducks/currentUser/types'
import * as drafts2 from 'ducks/drafts2/constants'
import { EDITOR_PINNED } from 'ducks/flags/flagNames'

import storage from 'util/storage'
import {
  UNDO_SEND_STARTED,
  UNDO_SEND_SUCCESS,
} from 'ducks/undoSend/actionTypes'

const defaultState = {
  isFocused: false,
  isVisible: false,
  isPinned: false,
  mode: 'reply',
}

const updatePinnedFromUser = (draftState, { data: { currentUser } }) => {
  const isPinned = currentUser.flags?.includes(EDITOR_PINNED)

  // We had used storage for this prefrence before, need to respect it too
  draftState.isPinned = storage.get('editorPinned') ? true : isPinned
}

const showEditor = draftState => {
  draftState.isVisible = true
}

const resetReplyMode = (draftState, action) => {
  if (action.meta?.fromDrawerAction) {
    draftState.mode = 'reply'
    return
  }

  draftState.mode = 'reply'
  draftState.isVisible = !!action?.payload?.replying
}

const showNoteEditor = draftState => {
  if (draftState.isVisible) return

  draftState.isVisible = true
  draftState.mode = 'note'
}

const editor = createSlice({
  name: 'editor',
  initialState: defaultState,
  reducers: {
    CHANGE_EDITOR_FOCUS: (draftState, { payload: { isFocused } }) => {
      draftState.isFocused = isFocused
    },
    SET_EDITOR_MODE: (draftState, { payload: mode }) => {
      draftState.mode = mode
    },
    UPDATE_EDITOR_VISIBILITY: (draftState, action) => {
      draftState.isVisible = !!action.payload.isVisible
    },
    UPDATE_EDITOR_PINNED: (draftState, action) => {
      draftState.isPinned = !!action.payload.isPinned
    },
  },
  extraReducers: builder => {
    builder
      .addCase(types.UPDATE_APP_DATA, updatePinnedFromUser)
      .addCase(FETCH_CURRENT_USER_SUCCESS, updatePinnedFromUser)
      .addCase(UNDO_SEND_STARTED, showEditor)
      .addCase(UNDO_SEND_SUCCESS, showEditor)
      .addCase(pages.SEARCH_PAGE, resetReplyMode)
      .addCase(pages.TICKET_PAGE, resetReplyMode)
      .addCase(pages.TICKET_COMMENT_PAGE, showNoteEditor)
      .addCase(pages.TICKET_REPLY_PAGE, showEditor)
      .addCase(pages.TICKET_REPLY_CHANGESET_PAGE, showEditor)
      .addCase(pages.TICKET_REPLY_DIRECT_PAGE, showEditor)
      .addCase(pages.TICKET_REPLY_DIRECT_CHANGESET_PAGE, showEditor)
      .addCase(pages.TICKET_FORWARD_CHANGESET_PAGE, showEditor)
      .addCase(pages.TICKET_FORWARD_PAGE, showEditor)
      .addCase(drafts2.DELETE_DRAFT, draftState => {
        draftState.isVisible = false
      })
  },
})

export default editor.reducer
